export const DATA_TYPES = {
  SINGLE_CELL: "single_cell_data",
  OTHERS: "other",
} as const;

export type DataType = (typeof DATA_TYPES)[keyof typeof DATA_TYPES];

export const DATA_TYPE_LABELS = {
  [DATA_TYPES.SINGLE_CELL]: "Single Cell Data",
  [DATA_TYPES.OTHERS]: "Others",
} as const;
